import { render } from "./BranchesCard.vue?vue&type=template&id=40c9d934&scoped=true"
import script from "./BranchesCard.vue?vue&type=script&lang=js"
export * from "./BranchesCard.vue?vue&type=script&lang=js"

import "./BranchesCard.vue?vue&type=style&index=0&id=40c9d934&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c9d934"]])

export default __exports__